import * as React from "react";
import { withStyles, WithStyles, Theme, createStyles, StyleRulesCallback } from "../mui/styles";
import classNames from 'classnames';
import { SortDirection, SortModel } from "../../data/DataSource";
import { HeaderColumn, DataGridPadding, DataGridLines } from "./Types";
import { TableCell, TableSortLabel } from "../widget";

const getSortFields = function (field?: string, direction?: SortDirection): SortModel {

    if (field !== undefined) {
        return { field: field, direction: direction };
    }

    //    return null;
}

export interface DataGridHeaderCellProps extends HeaderColumn {
    gridLines?: DataGridLines;
    firstCol: boolean;
    padding?: DataGridPadding;
}

declare type Props = DataGridHeaderCellProps & WithStyles<typeof styles>;

class DataGridHeaderCell extends React.PureComponent<Props> {

    constructor(props: Props) {
        super(props);

    }

    render() {

        const { field, title, isSorted, onSort, allowSorting, sortDirection, padding, classes, firstCol, gridLines, colSpan, rowSpan } = this.props;

        const onClick = allowSorting === true ? (e: any) => {
            const sortDir = sortDirection === 'asc' ? 'desc' : 'asc';
            onSort(getSortFields(field, sortDir), e.ctrlKey !== true);
        } : () => { };

        const className = classNames({
            [classes.root]: true,
            [classes.horizontalLines]: gridLines === 'horizontal' || gridLines === 'both',
            [classes.verticalLines]: firstCol === false && (gridLines === 'vertical' || gridLines === 'both'),

            [classes.paddingNone]: padding === 'none',
            [classes.paddingDense]: padding === 'dense',
            [classes.paddingExtraDense]: padding === 'extra-dense',

        })

        const sortLabelProps = {
            active: isSorted,
            direction: sortDirection,
            onClick: onClick
        }

        return <TableCell variant="head" className={className} colSpan={colSpan} rowSpan={rowSpan}>
            {allowSorting ? <TableSortLabel {...sortLabelProps}>
                {title}
            </TableSortLabel> : title}
        </TableCell>;
    }
}

const styles = ((theme: Theme) => {

    return createStyles({

        root: {
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            overflowX: 'hidden',
            paddingLeft: 8,
            paddingRight: 8,
            borderBottom: 'none',
            //     borderBottom: '1px solid ' + theme.palette.divider,
        },

        horizontalLines: {
            //       borderBottom: '1px solid ' + theme.palette.divider,
        },

        verticalLines: {
            borderLeft: '1px solid ' + theme.palette.divider,
        },


        paddingNone: {
            padding: 0,
        },

        paddingExtraDense: {
            padding: 4,
        },

        paddingDense: {
            padding: 8,
        },



        body: {
        },


        head: {
        },

        footer: {
        },
    })
}) as StyleRulesCallback;

export default withStyles(styles, { name: 'DataGridHeaderCell' })(DataGridHeaderCell);
